export default "A short poem, composed of images, sounds and texts.\n"